module.exports = __webpack_public_path__ + "img/Iconen Class Action website-04.57d9d4a1.svg";